import { LegalPage } from "@/components/LegalPage";

export default function Privacy() {
  return <LegalPage page="privacy" testId="privacy-page" />;
}
